import styled from "styled-components"
import { useDataLayerContext } from "../ContextLayer/DataProvider/DataProvider";
import { useEffect } from "react";
import gsap from "gsap";
import $ from "jquery";
import { DictionaryTagEntryType } from "../ContextLayer/DataProvider/types";

const TagSelectorModalCurtain = styled.div<{$visible: boolean}>`
    position: fixed;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    z-index: 100;
    color: white;
    pointer-events: none;
    background-color: rgba(0, 0, 0, 0);

    // white-space: no-wrap;
    flex-wrap: wrap;

    // transition: background-color 300ms;
`

const WrapperAtom = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 6px;
    width: 100vw;
    padding-left: 10px;
    padding-right: 10px;
    flex-wrap: wrap;
`

const TagAtom = styled.div<{$selected: boolean}>`
    // height: 40px;
    padding: 5px 15px 5px 15px;
    border-radius: 100px;
    color: #101010;
    border: 2px solid white;
    background-color: ${props => props.$selected ? 'rgba(248, 166, 145, 1)' : 'white'};
    opacity: 0;
    cursor: pointer;
`

interface TagSelectorModalProps {
    visible?: boolean,
    closeHandler: () => void
}

export default function TagSelectorModal({ visible = false, closeHandler }: TagSelectorModalProps) {
    const { dataLayer, setDataLayer } = useDataLayerContext();

    useEffect(() => {
        const clickHandler = (e: MouseEvent) => {
            if((e.target as HTMLDivElement).getAttribute('id') === 'tagSelectorModalCurtain') {
                // setTimeout(() => {
                    const tl = gsap.timeline();
                    tl.to('#modalTagWrapper div', {
                        opacity: 0,
                        duration: 0.2,
                        stagger: {
                            each: 0.02,
                            from: 'random'
                        },
                        ease: "power2.inOut",
                    });

                    tl.to('#tagSelectorModalCurtain', {
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        duration: 0.2,
                        ease: "power2.inOut",
                        onComplete: () => {
                            $('#tagSelectorModalCurtain').css('pointer-events', 'none');
                            closeHandler();
                        }
                    });
                // }, 520);
                return;
            }

            const newAggregatedTags = (dataLayer?.tags || []).map((t: DictionaryTagEntryType) => {
                let newSelectedValue = false;
                if(t.tag === (e.target as HTMLDivElement).innerHTML) {
                    newSelectedValue = !t.selected;
                }else{
                    newSelectedValue = t.selected;
                }
    
                return {
                    tag: t.tag,
                    selected: newSelectedValue
                }
            });
    
            setDataLayer({
                ...dataLayer,
                tags: newAggregatedTags
            });
        }

        const tagSelectorModalCurtain = document.getElementById('tagSelectorModalCurtain');
        
        if(dataLayer.tags?.length === 0) return;

        if(visible) tagSelectorModalCurtain?.addEventListener('click', clickHandler);

        if(visible) {
            gsap.to('#tagSelectorModalCurtain', {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                duration: 0.5,
                ease: "power2.inOut",
                onComplete: () => {
                    $('#tagSelectorModalCurtain').css('pointer-events', 'auto');
                }
            });

            gsap.to('#modalTagWrapper div', {
                opacity: 1,
                duration: 0.2,
                delay: 0.2,
                stagger: {
                    each: 0.03,
                    from: 'random'
                },
                ease: "power2.inOut",
            });
        }

        return () => {
            if(visible) tagSelectorModalCurtain?.removeEventListener('click', clickHandler);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, dataLayer.tags])

    return (
        <TagSelectorModalCurtain id="tagSelectorModalCurtain" $visible={visible}>
            <WrapperAtom id='modalTagWrapper'>
                {dataLayer.tags?.map((tag, index) => <TagAtom key={index} $selected={tag.selected}>{tag.tag}</TagAtom>)}
            </WrapperAtom>
        </TagSelectorModalCurtain>)
}